<template>
  <!-- jxd 之前的@blur="endEdit，但会影响selsctSummary事件触发，因为在点击li的时候，textarea会失去焦点，导致事件不触发" -->
  <!-- 所以这里通过@blur="c"延时100毫秒触发endEdit，这样就不影响selsctSummary事件触发了,类似防抖 -->
  <div class="v-table-td-summary" @click="doEdit">
    <textarea
        v-if="editing"
        ref="textarea"
        v-model="summaryVal"
        @keydown.tab.prevent="onEnter"
        @keydown.enter.prevent="onEnter"
        @keydown.down.prevent="onDown"
        @keydown.up.prevent="onUp"
        @blur="delayedEndEdit"
        @input="checkSummaryLength"
        class="v-table-td-summary-edit"
    ></textarea>
    <div class="summarylist-div" v-if="editing && summaryList.length > 0">
      <ul class="summarylist-ul">
        <li v-for="(item,index) in summaryList" :key="index" @click.stop="selsctSummary(item,index)" :style="{ color: activeIndex === index ? 'white' : 'black' ,background: activeIndex === index ? '#3b91ff' : '' }">
          <div class="summary-item-container">
            {{ item }}
            <!-- 使用事件处理器删除对应项jxd -->
            <i @click.stop="() => delSummary(item, index)" class="h-icon-trash"></i>
          </div>
        </li>
      </ul>
    </div>
    <div class="p-8px" v-if="!editing">
      {{ summary }}
    </div>
  </div>
</template>
<script setup>

import {getCurrentInstance, nextTick, onMounted, ref, watch} from "vue";
import {getVTable} from "@components/VoucherTable/VtUtil";
import { useStore } from 'vuex';


const props = defineProps(['summary', 'rowIndex', 'detail',"voucherDetailList"]);
const store = useStore();
const textarea = ref(null)
const editing = ref(false)
const summaryVal = ref("")
let VTable = null;
//防抖
let blurTimeoutId;
const summaryList = ref([]);
const activeIndex = ref(-1);//jxd模拟选中

const onDown = () => {
  if(activeIndex.value !== summaryList.value.length - 1){
    activeIndex.value += 1;//jxd模拟选中
  }
}

const onUp = () => {
  if(activeIndex.value !== -1){
    activeIndex.value -= 1;//jxd模拟选中
  }
}

//模糊匹配
const fuzzyMatching = (val) =>{
  // console.log('模糊匹配')
  summaryList.value = JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)) ? JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)):[];
  if(summaryList.value.length > 0){summaryList.value = summaryList.value.filter(item => item.toLowerCase().includes(val.toLowerCase()));}
}
//首次加载获得缓存到组件变量
const getSummary = () =>{
  // console.log(store.state.currentAccountSets.id);
  summaryList.value = JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)) ? JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)):[];
  // console.log('获取缓存',summaryList.value )
}
//保存缓存中没有的摘要到缓存
const saveSummary = (item) =>{
  // console.log(item,'保存缓存',summaryList.value)
  if(!summaryList.value.includes(item) && item){
    summaryList.value = JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)) ? JSON.parse(localStorage.getItem('summaryList' + store.state.currentAccountSets.id)):[];
    //现在的缓存不存在于数组中，写入进去
    // console.log(summaryList.value)
    summaryList.value.push(item);
    // console.log(summaryList.value)
    //在写入到缓存中
    localStorage.setItem('summaryList' + store.state.currentAccountSets.id,JSON.stringify(summaryList.value));
  }
}
//选中的缓存填充到表格
const selsctSummary = (item,index) => {
  getSummary();
  summaryVal.value = item;
  endEdit();
};
//删除选中的缓存
const delSummary = (item,index) =>{
  // console.log(index,summaryList.value,"删除缓存")
  summaryList.value.splice(index,1);
  localStorage.setItem('summaryList' + store.state.currentAccountSets.id,JSON.stringify(summaryList.value));
  getSummary();
}
//防抖
const delayedEndEdit = () => {
  clearTimeout(blurTimeoutId);
  blurTimeoutId = setTimeout(() => {
    //jxd模拟选中
    activeIndex.value = -1;
    endEdit();
  }, 150); // 这里的50毫秒可以根据实际情况调整
};
//超过长度禁止录入jxd
const checkSummaryLength = (event) => {
  // console.log('我执行了',summaryVal.value.trim())
  if(summaryVal.value.trim().length > 0){fuzzyMatching(summaryVal.value.trim());}
  if (summaryVal.value.length > 255) {
    summaryVal.value = summaryVal.value.substring(0, 255); // 截断超出的字符
    event.preventDefault(); // 阻止默认的输入行为
  }
};

const doEdit = () => {
  getSummary();
  //额外就是把voucherDetailList从VTable中传递过来
  //jxd获得了rowIndex和voucherDetailList，rowIndex是当前操作行的下标，voucherDetailList是整个凭证的列表
  //现在通过下标，在列表中找上一个分录的摘要，直至找到为止，如果第一行或者没有则就是空
  //摘要复制上行搞定了jxd
  let value = "";
  if (props.rowIndex !== 0) { // 如果是第一行，则不执行任何操作
    if(props.voucherDetailList[props.rowIndex].summary == ''){
      if(props.voucherDetailList.length > 0){
        let index = props.rowIndex - 1;
        for (let i = index; i >= 0; i--) {  
          if (props.voucherDetailList[i].summary !== '') {  
            value = props.voucherDetailList[i].summary;
            break; // 找到后直接跳出循环
          }  
        }
        if (value === "") { // 如果遍历结束都没有找到非空摘要，则赋值为空
          value = "";
        }
      }
      summaryVal.value = value;
    }
  }
  editing.value = true;
  nextTick(() => {
    textarea.value.focus();
    textarea.value.select();
  })
}

const endEdit = () => {
  // console.log('写完了')
  saveSummary(summaryVal.value.trim())
  editing.value = false;
  VTable.exposed.updateFiled(props.rowIndex, 'summary', summaryVal.value);
}

const onEnter = (e) => {
  //jxd模拟选中
  if(activeIndex.value !== -1){
    summaryVal.value = summaryList.value[activeIndex.value];
  }
  activeIndex.value = -1;
  editing.value = false;
  endEdit();
  VTable.exposed.next(props.rowIndex, 'subject');
}

watch(() => props.summary, (val) => {
  // console.log(val)

  summaryVal.value = val;
})

onMounted(() => {
  getSummary();
  summaryVal.value = props.summary;
  VTable = getVTable(getCurrentInstance())
})

defineExpose({
  doEdit,
  endEdit
})
</script>
<style scoped lang="less">
.v-table {
  &-td {
    &-summary {
      width: 210px;
      border-right: @border;

      &-edit {
        resize: none;
        outline: none;
        height: 100%;
        width: 100%;
        overflow: hidden;
        font-size: 12px;
        padding: 8px;

        &:focus {
          border: 1px solid @green-color;
        }
      }
    }
  }
}
// jxd样式调整，非选中下超宽
.p-8px {
  padding: 8px;
  overflow: hidden;
  height: 100%;
  overflow-wrap: break-word;
}
.summarylist-div{
  margin-top: -4px;
}
.summarylist-ul{
  list-style-type: none;
  position: relative;
  background: white;
  z-index: 999;
  height: 140px;
  overflow: auto;
  border: #f5f5f5 solid 1px;
  box-shadow: 3px 3px 5px 0 rgba(0, 0, 0, 0.3);
  li{
    padding: 0 6px 0 6px;
    font-size: 14px;
    // height: 26px;
    line-height: 26px;
  }
  li:hover{
    background-color: #f5f5f5;
    padding: 0 6px 0 6px;
    font-size: 14px;
    // height: 26px;
    line-height: 26px;
  }
}
.summary-item-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
